var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patientDetail"},[_c('PatientDetail'),_c('PatientTreatmentList',{attrs:{"treatmentHistoryDetailRoute":"SuperAdminPatientTreatmentDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }